import type { AgentSessionsOptions, AgentSessionsResult } from './types';
import { useAgentSessionsData } from './useAgentSessionsData';
import { useAgentSessionsLiveUpdates } from './useAgentSessionsLiveUpdates';

/**
 * Reads account-scoped Rovo agent sessions.
 *
 * Performs an initial Relay read and observes Relay-store updates. In a
 * browser, events update loaded sessions through Relay; events for sessions outside
 * the loaded connection coalesce into authoritative background list refreshes.
 */
export const useAgentSessions = (options: AgentSessionsOptions): AgentSessionsResult => {
	const data = useAgentSessionsData(options);
	useAgentSessionsLiveUpdates({
		options,
		data,
	});
	return data.result;
};
